module.exports = __webpack_public_path__ + "images/emoji/floppy_disk.31dc2eb32586995c6806.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/floppy_disk.png
// module id = vhpx
// module chunks = 2